import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore.ts'

export const useContentAssetStore = defineStore('ContentAssetStore', {
  state: () => {
    return { ...modelCollectionState('contentAssets') }
  },
  getters: { ...modelCollectionGetters('contentAssets') },
  actions: {
    ...modelCollectionActions('contentAssets'),
  },
})
